import type { ReactNode } from 'react';
import { createContext } from 'react';

export type LayoutContextType = {
  setLayoutStyle: (layoutStyle?: React.CSSProperties) => void;
  setTitle: (title: string) => void;
  setRenderTitle: (renderer?: () => ReactNode) => void;
};

const OnboardingLayoutContext = createContext<LayoutContextType>({
  setLayoutStyle: () => {},
  setTitle: () => {},
  setRenderTitle: () => {},
});

export default OnboardingLayoutContext;
